import { Component } from '@angular/core';

import { environment } from '../../environments/environment';

// Syncfusion packages
import { UploaderModule, UploadingEventArgs } from '@syncfusion/ej2-angular-inputs';
import { EmitType } from '@syncfusion/ej2-base';

@Component({
  selector: 'app-upload-file',
  imports: [UploaderModule],
  templateUrl: './upload-file.html',
  styleUrl: './upload-file.scss'
})
export class UploadFile {

  protected readonly apiUrl = environment.apiUrl;
  private readonly baseUrl = environment.apiUrl;
  private readonly uploadUrl = `${this.baseUrl}/api/Upload/upload`;

  public dropEle?: HTMLElement;

  public uploadPaths: Object = {
    saveUrl: this.uploadUrl,
  }

  constructor() { }

  ngOnInit() {
    this.dropEle = document.getElementById('droparea') as HTMLElement;
  }

  public onUploadSuccess(args: any): void {
    console.log('Upload Successful!');
  }

  public onUploadFailure(args: any): void {
    console.log('Upload Failed!');
  }

  public onFileUpload: EmitType<UploadingEventArgs> = (args: any) => {
    console.log('File Upload Started');

    console.log(args.keys);
  } 

}
